(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    const parseCombinations = (picker) => {
    const script = picker.querySelector('[data-variant-combinations]');
    if (!script?.textContent) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  };

  const selectedOptionValueIds = (picker) =>
    Array.from(picker.querySelectorAll('fieldset input:checked, select option[selected]'))
      .map((node) => node.dataset.optionValueId)
      .filter(Boolean);

  const comboMatches = (combo, ids) => {
    const wanted = new Set(ids.map(String));
    return combo.option_value_ids.length === wanted.size
      && combo.option_value_ids.every((id) => wanted.has(String(id)));
  };

  const findCompatibleCombo = (combos, requiredId, preferredIds) => {
    const matches = combos.filter((combo) =>
      combo.option_value_ids.map(String).includes(String(requiredId))
    );
    matches.sort((left, right) => {
      const leftShare = preferredIds.filter((id) => left.option_value_ids.map(String).includes(String(id))).length;
      const rightShare = preferredIds.filter((id) => right.option_value_ids.map(String).includes(String(id))).length;
      if (rightShare !== leftShare) return rightShare - leftShare;
      return Number(right.available) - Number(left.available);
    });
    return matches[0] || null;
  };

  const applyCombo = (picker, combo) => {
    const wanted = new Set(combo.option_value_ids.map(String));
    for (const input of picker.querySelectorAll('fieldset input[data-option-value-id]')) {
      input.checked = wanted.has(String(input.dataset.optionValueId));
    }
    const fieldset = picker.querySelector('fieldset:last-of-type') || picker.querySelector('form');
    for (const id of wanted) {
      if (picker.querySelector(`[data-option-value-id="${id}"]`)) continue;
      const hidden = document.createElement('input');
      hidden.type = 'radio';
      hidden.checked = true;
      hidden.hidden = true;
      hidden.dataset.optionValueId = id;
      fieldset?.appendChild(hidden);
    }
    for (const option of picker.querySelectorAll('select option[data-option-value-id]')) {
      if (wanted.has(String(option.dataset.optionValueId))) {
        option.selected = true;
        option.setAttribute('selected', 'selected');
      } else {
        option.selected = false;
        option.removeAttribute('selected');
      }
    }
  };

  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      const optionNode = target instanceof HTMLSelectElement
        ? target.selectedOptions[0]
        : target;
      if (!(optionNode instanceof HTMLElement) || !optionNode.dataset.optionValueId) return;

      const picker = target.closest('variant-picker');
      if (!picker) return;

      const combos = parseCombinations(picker);
      if (!combos.length) return;

      const selectedIds = selectedOptionValueIds(picker);
      if (combos.some((combo) => comboMatches(combo, selectedIds))) return;

      const preferredIds = selectedIds.filter((id) => id !== optionNode.dataset.optionValueId);
      const combo = findCompatibleCombo(combos, optionNode.dataset.optionValueId, preferredIds);
      if (combo) applyCombo(picker, combo);
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
